<template>
  <div class="com-page" v-wechat-title="this.title">
    <div class="header_download flex">
      <div class="flex">
        <img class="logo2" src="../../assets/logo2.png" alt="" />
        <img class="voiceLogo2" src="../../assets/voiceLogo2.png" alt="" />
      </div>
      <img src="../../assets/btn_download2.png" alt="下载" class="download" @click="download" />
    </div>
    <div class="comPage-compere">
      <div class="topCon">
        <img class="avatar" :src="compereMsg.avatar" alt="" />
        <!-- <div class="flex follow">
          <div class="follow_text" @click="download()">关注</div>
          <div class="private" @click="download()">私信</div>
        </div> -->
        <div class="comMessage">
          <div class="flex">
            <p class="comname">{{ compereMsg.nickname }}</p>
            <img class="sex" v-show="compereMsg.gender == 'f'" src="../../assets/woman.png" alt="" />
            <img class="sex" v-show="compereMsg.gender == 'm'" src="../../assets/man.png" alt="" />
          </div>
          <div class="number">听见号{{ compereMsg.number }}</div>
          <div class="labels flex">
            <div>{{ compereMsg.city || '未知星球' }}</div>
            <div>{{ compereMsg.constellation }}</div>
            <div v-if="compereMsg.host_rank">{{ compereMsg.host_rank }}</div>
          </div>
          <div class="introduction">{{ compereMsg.slogan }}</div>
          <div class="attFens">
            <span class="attentionNum">{{ compereMsg.stars | peopleNumber }}</span>
            <span v-if="compereMsg.stars !== undefined && compereMsg.stars.length >= 5" style="font-size: 0.25rem; color: rgba(102, 102, 102, 1)">w</span>
            <font class="att-font">关注</font>
            <i></i>
            <span class="fensNum">{{ compereMsg.fans | peopleNumber }}</span>
            <span v-if="compereMsg.fans !== undefined && compereMsg.fans.length >= 5" style="font-size: 0.25rem; color: rgba(102, 102, 102, 1)">w</span>
            <font class="att-font">粉丝</font>
             <i></i>
            <span class="fensNum">{{ compereMsg.visit | peopleNumber }}</span>
            <span v-if="compereMsg.visit !== undefined && compereMsg.visit.length >= 5" style="font-size: 0.25rem; color: rgba(102, 102, 102, 1)">w</span>
            <font class="att-font">访客</font>
          </div>
        </div>
      </div>

      <div>
        <div class="more_title">更多推荐</div>
        <div class="table_bar_item">
      <programcommenNew :commenProgram="recommendRecorded"></programcommenNew>
    </div>
      </div>
    </div>

    <div style="height:1rem"></div>


    <myfooter></myfooter>
    <toast :msg="msg"></toast>
  </div>
</template>

<script>
import myfooter from "../commen/myfooter";
import cbct from "../../../static/js/base.js";
import share from "../../../static/js/share.js";
import toast from "../commen/toast.vue";
import router from "../../router";
import qs from "qs";
import programcommenNew from "../commen/programcommenNew";

export default {
  name: "share",
  props: {},
  data() {
    return {
      compereMsg: [],
      recommen1: [],
      recommen2: [],
      sex: [],
      iscur: 0,
      msg: "",
      number: "",
      stars: "",
      fans: "",
      type: "",
      title: "",
      isPage: "的主页",
      appName: "-听见广播",
      radioName: "",
      channelName: "",
      pName: [],
      recommendRecorded: [],
    };
  },
  filters: {
    peopleNumber: function (n1) {
        n1 = n1
         if (n1!="") {
            let strNum="";
         if (n1 >= 0 && n1 < 10000) {
           strNum=n1
         }else{
           strNum=(parseFloat(n1/10000).toFixed(1))
         }
         return strNum     
         }
    },
  },
  created() {
    let self = this;
    if (self.$route.query.number) {
      self.number = self.$route.query.number;
    }
    if (self.$route.query.hoster_id) {
      self.number = self.$route.query.hoster_id;
    }
    self.type = self.$route.query.type;
    // self.bus.$emit('loading',true);
    self.$api.post(cbct.baseurl + "share/home-page",qs.stringify({ number: this.number, type: this.type }))
      .then(function (res) {
        // self.bus.$emit('loading',false);
        console.log(res.c , cbct.code.successCode)
        if (res.c == cbct.code.successCode) {
          // console.log(res.d)
          res.d.avatar = cbct.imgUrlAvatar()+res.d.avatar
          self.compereMsg = res.d;
            if (res.d.programme_recommend.length > 0) {
              self.recommendRecorded = res.d.programme_recommend;
            } else if (res.d.programme_recommend.length == 0) {
              self.recommendRecorded=['none'];
            }
            console.log(self.recommendRecorded)
          if (res.d.is_del == "1") {
            self.$router.push({
              path: "delPage",
            });
            return;
          }
          share.share(self,window.location.href,res.d.nickname + "的主页","“" +res.d.nickname +"”的听见广播个人主页，主持很不错，快来关注吧！",res.d.avatar,res.d.nickname + "的主页");
          share.QQshare(window.location.href,res.d.nickname + "的主页","“" +res.d.nickname +"”的听见广播个人主页，主持很不错，快来关注吧！",res.d.avatar);
          if (self.$route.query.title) {
            self.title = self.$route.query.title + self.appName;
          } else {
            self.title = res.d.nickname + self.isPage + self.appName;
          }
          self.radioName = res.d.radio_name;
          self.channelName = res.d.channel_name;
          if (res.d.programme.length != 0) {
            self.pName = res.d.programme;
          }

          
        } else {
          self.bus.$emit("toast", { show: true, title: res.m });
        }
      })
      .catch((res) => {
        //  console.log(res);
      });
  },
  methods: {
        checkTab(order) {
      this.currentTab = order;
    },
    toDownloadpage() {
      //点击下载
      this.$router.push({path:"downloadApp?isFrom=programRecorded"});
    },
    nextChannel: function (id) {
      this.$router.push({
        path: "ratePage?channel_id=" + id,
      });
    },
    nextP: function (number, title) {
      this.$router.push({
        path:
          "programStop?isendShare=0&programme_id=" +
          number +
          "&type=1&title=" +
          title,
      });
    },
    download() {
      //点击下载
      this.$router.push({
        path:
          "downloadApp?isFrom=programRecorded&is_live=" +
          this.isLive +
          "&number=" +
          this.number,
      });
    },
  },

  components: {
    myfooter,
    toast,
    programcommenNew,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header_download {
  width: 100%;
  height: 0.88rem;
  background: #e8e8e8;
  justify-content: space-between;
}
.header_download .logo2 {
  width: 0.72rem;
  height: 0.74rem;
  /* margin: 0.12rem 0 0.1rem 0.22rem; */
  margin: 0 0.28rem 0 0.48rem;
}
.header_download .voiceLogo2 {
  height: 0.4rem;
  width: auto;
}
.header_download .download {
  width: 1.42rem;
  height: 0.6rem;
  margin: 0.2rem 0.36rem 0.2rem 0;
}
li {
  list-style: none;
}
.downloadApp {
  box-sizing: border-box;
}
.clear {
  clear: both;
}
.downloadApp p {
  height: 0.76rem;
  width: 4.4rem;
  margin: 0.35rem auto 0.34rem;
}
.downloadApp p img {
  width: 100%;
  height: 100%;
}
.channelName {
  display: flex;
  padding: 0.18rem 0 0.22rem;
  border-top: solid 0.01rem rgba(221, 221, 221, 1);
  /* overflow: hidden; */
}

.channelName .title {
  font-size: 0.28rem;
  color: rgba(0, 0, 0, 0.8);
  line-height: 0.4rem;
  font-weight: 800;
}
.boldLine {
  height: 0.2rem;
  background: rgba(248, 248, 248, 1);
}
.pnameCon {
  /* border: solid 1px; */
  width: 100%;
}
.pnameCon img {
  width: 0.22rem;
  float: right;
}

.com-page {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background: #f7f8f9;
}
.comPage-compere {
  width: 100%;
  overflow: hidden;
  background-image: url("../../assets/bg2.png");
  background-size: 100% 3.04rem;
  background-repeat: no-repeat;
}
.topCon {
  /* width: 100%; */
  box-sizing: border-box;
  margin: 1.42rem 0.3rem 0;
  padding: 0.02rem 0 .3rem;
  position: relative;
  background: white;
  border-radius: 0.16rem;
}
.comMessage {
  width: 100%;
  box-sizing: border-box;
  margin-top: 1.48rem;
  padding: 0rem 0.4rem 0;
  /* display: flex; */
  align-items: center;
  /* border-bottom: solid 0.01rem rgba(221,221,221,1) */
}
.comImg {
  width: 1.45rem;
  height: 1.44rem;
  margin-top: 0.14rem;
  vertical-align: middle;
}
.avatar {
  width: 1.72rem;
  height: 1.72rem;
  position: absolute;
  top: -0.6rem;
  left: 0.4rem;
  border-radius: 100%;
  border: 2px solid #ffffff;
}
.follow {
  position: absolute;
  top: 0.24rem;
  right: 0.4rem;
}
.follow .follow_text {
  width: 1.8rem;
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  background: #ff3c39;
  color: white;
  font-size: 0.24rem;
  border-radius: 0.36rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.follow .private {
  width: 1.1rem;
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  margin-left: 0.12rem;
  background: #f8f8f8;
  color: #000000;
  font-size: 0.24rem;
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.comImg > img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.comMsg {
  width: 2.92rem;
  margin-left: 0.36rem;
  text-align: left;
  /* line-height: 0.25rem; */
}
.comname {
  /* height: 0.35rem; */
  color: #000000;
  letter-spacing: 20;
  font-size: 0.4rem;
  margin-right: 0.2rem;
}
.sex {
  width: 0.28rem;
  height: 0.28rem;
}
.number {
  font-size: 0.24rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  text-align: left;
  padding: 0.16rem 0 0.32rem;
}
.labels > div {
  padding: .04rem .08rem;
  text-align: center;
  margin-right: 0.16rem;
  font-size: 0.22rem;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 0.28rem;
  color: rgba(0, 0, 0, 0.5);
}
.introduction {
  line-height: 1.4;
  padding: 0.24rem 0 0.32rem;
  text-align: left;
  font-size: 0.28rem;
  color: rgba(0, 0, 0, 0.5);
}
.attFens {
  height: 0.2rem;
  line-height: 0.2rem;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.attentionNum,
.fensNum {
  font-size: 0.36rem;
  color: rgba(0, 0, 0, 1);
  font-weight:500
}

.att-font,
.fens-font {
  font-size: 0.21rem;
  color: rgba(153, 153, 153, 1);
}
.att-font {
  margin: 0 0.17rem 0 0.12rem;
}
.fensNum {
  margin: 0 0 0 0.14rem;
}
.flex {
  display: flex;
  align-items: center;
}
.table_bar_item{
  margin: 0 .3rem;
}
.more_title{
  font-size: .36rem;
  font-weight: 500;
  color: #000000;
  text-align: left;
  margin-left: .3rem;
  padding: .32rem 0 .2rem;
}
</style>
